import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialog, MatDialogConfig, MatDialogModule } from '@angular/material/dialog';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTable, MatTableModule } from '@angular/material/table';
import { BaseDto } from '@models/base/baseDto.model';
import { AccionesDialog } from '@models/base/identificadores.model';
import { ContactoDto } from '@models/contacto/contactoDto.model';
import { TareaFilter } from '@models/tarea/tareaFilter.model';
import { ContactoService } from '@services/contacto/contacto.service';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { DialogDeleteComponent } from 'src/app/component/dialog-delete/dialog-delete.component';import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { isFalsy } from 'utility-types';
import { SharedModule } from '@modules/shared.module';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { ButtonNewComponent } from '@component/button-new/button-new.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { SinDatosParaMostrarComponent } from '@component/sin-datos-para-mostrar/sin-datos-para-mostrar.component';
import { AppRolesDirective } from '@directives/appRoles/app-roles.directive';
import { DialogFormContactoComponent } from '../dialog-form-contacto/dialog-form-contacto.component';
import { DialogParams } from '@interfaces/dialogParam.interface.model';
import { ButtonFilterTableClearComponent } from '@component/button-filter-table-clear/button-filter-table-clear.component';
import { ButtonFilterTableComponent } from '@component/button-filter-table/button-filter-table.component';

@Component({
  standalone: true,
  imports: [ MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatCardModule, MatIconModule, MatButtonModule, MatDividerModule, NgxSpinnerModule, MatTableModule, MatSliderModule, MatSlideToggleModule, MatMenuModule, MatDialogModule, MatDatepickerModule, MatExpansionModule, MatRadioModule, MatSelectModule,  ButtonNewComponent,  MatFormFieldModule, MatInputModule, ReactiveFormsModule, MatCardModule, MatIconModule, MatButtonModule, CommonModule, FormsModule, MatSortModule, NgxSpinnerModule, FormsModule, ReactiveFormsModule, CommonModule, MatTooltipModule, MatPaginatorModule, MatRippleModule, RouterModule, MatCheckboxModule,AppRolesDirective,SinDatosParaMostrarComponent,ButtonFilterTableClearComponent,ButtonFilterTableComponent],
  selector: 'app-list-contacto',
  templateUrl: './list-contacto.component.html',
  styleUrls: ['./list-contacto.component.css'],
})
export class ListContactoComponent {

accionesDialog = AccionesDialog;
  @Input() idPersona!: number
  @Output() contactosLoad: EventEmitter<ContactoDto[]> = new EventEmitter();
  data = false
  displayedColumns: string[] = [];
  dataSource = new MatTableDataSource<ContactoDto>();
  formBuilder = new FormBuilder
  formFilter: any;
  checkedFiltroAvanzado: boolean = false;
  lstEstados: BaseDto[] = [
    { id: 0, descripcion: 'Todos' },
    { id: 1, descripcion: 'Pendiente' },
    { id: 2, descripcion: 'En Proceso' },
    { id: 3, descripcion: 'Finalizado' },
  ];
  constructor(
    private contactoService: ContactoService,
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
    private breakpointObserver: BreakpointObserver,
    private dialog: MatDialog
  ) {

    this.breakpointObserver.observe(['(max-width: 600px)']).subscribe(result => {
      this.displayedColumns = result.matches ?
        ["tipoContacto", "valorContacto","accion"] :
        ["tipoContacto", "valorContacto", "preferido", "accion"];
    });

    this.formFilter = this.formBuilder.group({
      Titulo: [''],
      EstadoTarea: [''],
      Prioridad: [''],
      FechaAltaDesde: [Date],
      FechaAltaHasta: [Date],
    })
  }

  @ViewChild(MatTable, { static: true }) table!: MatTable<any>;
  private paginator!: MatPaginator;
  private sort!: MatSort;

  @ViewChild(MatSort) set matSort(ms: MatSort) {
    this.sort = ms;
  }

  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  ngOnInit(): void {
    if (this.idPersona) {
      this.aplicarFiltro()
    }

  }

  filtrosAvanzados(event: any) {
    if (event.checked == true)
      this.checkedFiltroAvanzado = true
    else
      this.checkedFiltroAvanzado = false
  }

  aplicarFiltro() {
    this.getAllContactoFilter(this.idPersona)
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  getAllContactoFilter(idPersona: number) {
    this.spinner.show('spListado')
    this.contactoService.getAllByIdPersona(idPersona)
      .subscribe(
        data => {
          this.spinner.hide('spListado')
          this.dataSource.data = data
          this.data = this.dataSource.data.length >= 1 ? true : false
          this.contactosLoad.emit(data)

        },
        error => {
          this.spinner.hide('spListado')
          this.snackBar.showError(error, "Error");
        })
  }



  openDialog<T>(params: DialogParams<T>) {
      const { accion, entidad } = params;

      const data = {
        ...entidad,
        accion,
        idPersona: this.idPersona
      };

      const dialogConfig = new MatDialogConfig();
      dialogConfig.autoFocus = false

      switch (accion) {
        case AccionesDialog.Ver:
          dialogConfig.width = "30%"
          break;

        default:
          dialogConfig.width = "70%"
          break;
      }
      dialogConfig.data = data

      const dialogRef = this.dialog.open(DialogFormContactoComponent, dialogConfig);

      dialogRef.afterClosed().subscribe(result => {
        if (!result || !result.event) return;

        switch (result.event) {
          case AccionesDialog.Agregar:
            this.aplicarFiltro()
            break;
          case AccionesDialog.Modificar:
            this.aplicarFiltro()
            break;
          case AccionesDialog.Eliminar:
            this.aplicarFiltro()
            break;
          default:

            break;
        }

      });
    }

  isFalsy(valor: any) {
    return isFalsy(valor)
  }

  trackByItems(index: number, item: any): any { return item; }
}
